import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { environment } from '../../../environments/environment';
import { AuthService } from '../auth/auth.service';
import { TokenCommonService } from '../token-common.service';
import 'rxjs/add/operator/map';

@Injectable()
export class BandaInformacionService extends TokenCommonService {
  constructor(
    http: Http,
    authService: AuthService
  ) {
    super(http, authService);
  }

  getBandaInfo() {
    return this.tokenGet(`${environment.SF_API_V2}/banda-informacion`);
  }

  createBandaInfo(data: any) {
    return this.tokenPost(`${environment.SF_API_V2}/banda-informacion`, data);
  }

  updateBandaInfo(id: number, data: any) {
    return this.tokenV2Put(`${environment.SF_API_V2}/banda-informacion/${id}`, data);
  }

  revalidatePath() {
    return this.http.get(`${environment.SF_URL_V2}api/revalidate?path=banda-informacion`)
      .map(res => res.json());
  }
}



// WEBPACK FOOTER //
// /app/src/app/services/banda-informacion/banda-informacion.service.ts